import { css } from '@compiled/react';

import { wacToken } from '@/libraries/design/foundations';

export const JsmUseCaseProvisioningGrid = () => (
	<svg css={artworkGridStyles} viewBox="0 0 482 556" fill="none">
		<mask
			id="jsm-use-case-provisioning-grid-mask"
			css={artworkGridMaskStyles}
			maskUnits="userSpaceOnUse"
			x="52"
			y="54"
			width="388"
			height="448"
		>
			<path
				opacity="0.5"
				d="M340.137 54.1895L439.271 424.161L151.719 501.21L52.5857 131.239L340.137 54.1895Z"
				fill={wacToken('color.extended.blue200')}
			/>
		</mask>
		<g mask="url(#jsm-use-case-provisioning-grid-mask)">
			<GridLine x1="247.878" y1="60.0162" x2="-212.057" y2="60.0161" />
			<GridLine x1="247.878" y1="95.3746" x2="-212.057" y2="95.3745" />
			<GridLine x1="247.878" y1="130.733" x2="-212.057" y2="130.733" />
			<GridLine x1="247.878" y1="166.091" x2="-212.057" y2="166.091" />
			<GridLine x1="247.878" y1="201.45" x2="-212.057" y2="201.45" />
			<GridLine x1="247.878" y1="236.809" x2="-212.057" y2="236.809" />
			<GridLine x1="245.981" y1="272.167" x2="-210.161" y2="272.167" />
			<GridLine x1="248.826" y1="307.525" x2="-213.006" y2="307.525" />
			<GridLine x1="245.981" y1="342.883" x2="-210.161" y2="342.883" />
			<GridLine x1="245.981" y1="378.242" x2="-210.161" y2="378.242" />
			<GridLine x1="245.981" y1="413.6" x2="-210.161" y2="413.6" />
			<GridLine x1="245.981" y1="448.959" x2="-210.161" y2="448.959" />
			<GridLine x1="245.981" y1="484.317" x2="-210.161" y2="484.317" />
			<GridLine x1="228.264" y1="-276" x2="228.264" y2="825" />
			<GridLine x1="192.906" y1="-276" x2="192.906" y2="825" />
			<GridLine x1="157.547" y1="-276" x2="157.547" y2="825" />
			<GridLine x1="122.189" y1="-276" x2="122.189" y2="825" />
			<GridLine x1="86.8306" y1="-276" x2="86.8306" y2="825" />
			<GridLine x1="703.762" y1="60.0157" x2="243.826" y2="60.0156" />
			<GridLine x1="703.762" y1="95.3741" x2="243.826" y2="95.374" />
			<GridLine x1="703.762" y1="130.732" x2="243.826" y2="130.732" />
			<GridLine x1="703.762" y1="166.091" x2="243.826" y2="166.091" />
			<GridLine x1="703.762" y1="201.449" x2="243.826" y2="201.449" />
			<GridLine x1="703.762" y1="236.808" x2="243.826" y2="236.808" />
			<GridLine x1="701.865" y1="272.166" x2="245.723" y2="272.166" />
			<GridLine x1="704.71" y1="307.524" x2="242.878" y2="307.525" />
			<GridLine x1="701.865" y1="342.883" x2="245.723" y2="342.883" />
			<GridLine x1="701.865" y1="378.241" x2="245.723" y2="378.241" />
			<GridLine x1="701.865" y1="413.6" x2="245.723" y2="413.6" />
			<GridLine x1="701.865" y1="448.958" x2="245.723" y2="448.958" />
			<GridLine x1="701.865" y1="484.317" x2="245.723" y2="484.317" />
			<GridLine x1="437.639" y1="-276" x2="437.639" y2="825" />
			<GridLine x1="402.281" y1="-276" x2="402.281" y2="825" />
			<GridLine x1="366.922" y1="-276" x2="366.922" y2="825" />
			<GridLine x1="331.564" y1="-276" x2="331.564" y2="825" />
			<GridLine x1="296.206" y1="-276" x2="296.206" y2="825" />
			<GridLine x1="260.847" y1="-276" x2="260.847" y2="825" />
		</g>
	</svg>
);

const GridLine = ({
	x1,
	x2,
	y1,
	y2,
}: {
	readonly x1: string;
	readonly x2: string;
	readonly y1: string;
	readonly y2: string;
}) => (
	<line
		x1={x1}
		x2={x2}
		y1={y1}
		y2={y2}
		stroke={wacToken('color.primary.saffron')}
		strokeWidth="0.94832"
	/>
);

const artworkGridStyles = css({
	gridArea: '1 / 1',
	width: '482px',
	maxWidth: '100%',
	height: '556px',
});

const artworkGridMaskStyles = css({
	maskType: 'alpha',
});
